// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.4). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declarations, not reference copies — see hooks/useAuth.ts.
import * as _module from "@livingsyncs/ui";

export function isChunkLoadError(error: unknown): boolean {
  return _module.isChunkLoadError(error);
}
export function reloadOnceForStaleChunk(): boolean {
  return _module.reloadOnceForStaleChunk();
}
